export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var to_load_json_atlas = {
};


export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    "background"					: imgsPath + "reels/background_{q}.png",
    "reels_cover"					: imgsPath + "reels/cover_{q}.png",

    "settings_background_1"			: imgsPath + 'info/wintable_{q}.png',
    "settings_background_2"			: imgsPath + 'info/info_{q}.png',
    "settings_background_3"			: imgsPath + 'info/info_winlines_{q}.png',

    "winframe"						: imgsPath + "symbols/win_frame_{q}.png",

    "arrow_left"					: imgsPath + "reels/arrows/arrow_left_{q}.png",
    "arrow_7_left"					: imgsPath + "reels/arrows/arrow_7_left_{q}.png",
    "arrow_81_left"					: imgsPath + "reels/arrows/arrow_81_left_{q}.png",

    "arrow_right"					: imgsPath + "reels/arrows/arrow_right_{q}.png",
    "arrow_7_right"					: imgsPath + "reels/arrows/arrow_7_right_{q}.png",
    "arrow_81_right"				: imgsPath + "reels/arrows/arrow_81_right_{q}.png",


    'bigwin_bg'						: imgsPath + 'bigwin/bigwinbg_{q}.png',
    'bigwin_label'					: imgsPath + 'bigwin/bigwin_label_{q}.png',
    'megawin_label'					: imgsPath + 'bigwin/megawin_label_{q}.png',
    'supermegawin_label'			: imgsPath + 'bigwin/supermegawin_label_{q}.png',

    'winlines81'					: imgsPath + 'winlines/winlines81_{q}.png',
    'winlines7'						: imgsPath + 'winlines/winlines7_{q}.png',
};

for(let x = 0; x <= 6; x++) {
    to_load["winline7_" + x] = imgsPath + "winlines/winline7_" + x + "_{q}.png";
}

for(let z = 1; z <= 81; z++) {
    to_load["winline81_" + z] = imgsPath + "winlines/winline81_" + z + "_{q}.png";
}

export const to_load_audio = {
    "YOU_WON": audioPath + "bwin_BigWin.ogg",

    "REEL_BG_1": audioPath + "reel_Spin_1.ogg",
    "REEL_BG_2": audioPath + "reel_Spin_2.ogg",
    "REEL_BG_3": audioPath + "reel_Spin_3.ogg",

    "REEL_STOP_1": audioPath + "reel_Stop.ogg",

    "joker_bell": audioPath + "symbol_Joker.ogg",

    "win_symbol_Cherry": audioPath + "win_Cherry.ogg",
    "win_symbol_Lemon": audioPath + "win_Lemon.ogg",
    "win_symbol_Orange": audioPath + "win_Orange.ogg",
    "win_symbol_Plum": audioPath + "win_Plum.ogg",
    "win_symbol_Melon": audioPath + "win_Melon.ogg",
    "win_symbol_Grape": audioPath + "win_Grape.ogg",
    "win_symbol_Star": audioPath + "win_Star.ogg",
    "win_symbol_Seven": audioPath + "win_Seven.ogg",
    "win_symbol_Joker": audioPath + "win_Joker.ogg",
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'font_bigwin' : {
        'img':	imgsPath + 'fonts/font_bigwin.png',
        'xml':	imgsPath + 'fonts/font_bigwin.xml',
    },

    'font_wintable' : {
        'img':	imgsPath + 'fonts/font_wintable.png',
        'xml':	imgsPath + 'fonts/font_wintable.xml',
    }
};

import {madnes_audio_allow_multiple, madnes_set_audio_volume} from "../../framework/src/engine/madnes/madnes_audio";

export function set_sounds(server_config)
{
    var vol = 1;

    if(typeof server_config["volume"]["bigWin"] !== "undefined")
    {
        vol = server_config["volume"]["bigWin"];
        madnes_set_audio_volume('YOU_WON', vol);
    }

    if(typeof server_config["volume"]["buttonEffect"] !== "undefined")
    {
        vol = server_config["volume"]["buttonEffect"];
        madnes_set_audio_volume('button_click', vol);
    }

    if(typeof server_config["volume"]["spin"] !== "undefined")
    {
        vol = server_config["volume"]["spin"];

        madnes_set_audio_volume('REEL_BG_1', vol);
        madnes_set_audio_volume('REEL_BG_2', vol);
        madnes_set_audio_volume('REEL_BG_3', vol);
    }

    if(typeof server_config['volume']['stopReel'] != "undefined")
    {
        vol = server_config['volume']['stopReel'];

        madnes_set_audio_volume('REEL_STOP_1', vol);
    }

    if(typeof server_config["volume"]["winAnim"] !== "undefined")
    {
        vol = server_config["volume"]["winAnim"];

        madnes_set_audio_volume('win_symbol_Cherry', vol);
        madnes_set_audio_volume('win_symbol_Lemon', vol);
        madnes_set_audio_volume('win_symbol_Orange', vol);
        madnes_set_audio_volume('win_symbol_Plum', vol);
        madnes_set_audio_volume('win_symbol_Melon', vol);
        madnes_set_audio_volume('win_symbol_Grape', vol);
        madnes_set_audio_volume('win_symbol_Star', vol);
        madnes_set_audio_volume('win_symbol_Seven', vol);
        madnes_set_audio_volume('win_symbol_Joker', vol);
    }

    if(typeof server_config["volume"]["winCounter"] !== "undefined") {
        vol = server_config["volume"]["winCounter"];

        madnes_set_audio_volume('remittance_A', vol);
        madnes_set_audio_volume('remittance_B', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds1"] !== "undefined") {

        vol = server_config["miscSounds"]["miscSounds1"];

        madnes_set_audio_volume('coins_loop', vol);
    }

    if(typeof server_config["miscSounds"]["miscSounds2"] !== "undefined") {

        vol = server_config["miscSounds"]["miscSounds2"];

        madnes_set_audio_volume('joker_bell', vol);
    }
}

